module.exports = __webpack_public_path__ + "img/mensajes.4da67f41.svg";